import Config from '@shared/config/constants/config-main';
import axios from 'axios';

import { useAppLoadingContext } from '@shared/store/context/AppLoadingContext/AppLoadingContext';
import { EVENT_NAMES, LogService } from '@shared/services/LogService';
import { PAYMENT_GATEWAYS } from '@entities/payment-plan';
import { useQuery } from '@shared/hooks';
import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const ThreeDSAdyenRedirect = () => {
  const { query } = useQuery();
  // @ts-ignore
  const { setIsLoading } = useAppLoadingContext();
  const history = useHistory();

  const email = query.get('email');
  const billingPlan = query.get('billingPlan');
  const orderReference = query.get('orderReference');
  const redirectResult = query.get('redirectResult');

  const submitRedirectAdditionalData = useCallback(
    async (email, billingPlan, orderReference, redirectResult) => {
      const body = {
        email,
        billingPlan,
        orderReference,
        redirectResult,
      };

      const res = await axios.post(`${Config.API_URL}/v1/api/adyen/payments/details`, body);

      if (res.data.data?.activationToken) {
        LogService.handleEvent(EVENT_NAMES.cc_finish_flow, {
          paymentGateway: PAYMENT_GATEWAYS.ADYEN,
        });
        history.push({
          pathname: `/cc/welcome`,
          state: { activationURL: res.data.data.activationToken },
        });
      } else {
        LogService.handleEvent(EVENT_NAMES.cc_failed_flow, {
          paymentGateway: PAYMENT_GATEWAYS.ADYEN,
        });
        window.location.pathname = '/';
      }
      setIsLoading(false);
    },
    []
  );

  useEffect(() => {
    setIsLoading(true);
    if (email && billingPlan && orderReference && redirectResult) {
      submitRedirectAdditionalData(email, billingPlan, orderReference, redirectResult);
    }
  }, [
    email,
    billingPlan,
    orderReference,
    redirectResult,
    setIsLoading,
    submitRedirectAdditionalData,
  ]);

  return null;
};

export { ThreeDSAdyenRedirect };
